import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="container-wide section-padding">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-file-list-3-line text-white" />
              </div>
              <span className="font-heading font-semibold text-base">
                Kakobuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-4">
              Your trusted source for verified kakobuy spreadsheet finds,
              trusted sellers, and safe buying guides.
            </p>
            <p className="text-xs text-white/40">
              Updated weekly with fresh finds.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white/40 uppercase tracking-wider mb-4">
              Links
            </h4>
            <div className="space-y-2">
              <Link
                to="/"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Home
              </Link>
              <Link
                to="/blog"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Blog
              </Link>
              <Link
                to="/blog/best-kakobuy-spreadsheet"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Buying Guides
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Main Store
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white/40 uppercase tracking-wider mb-4">
              Categories
            </h4>
            <div className="space-y-2">
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Shoes
              </a>
              <a
                href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Hoodies & Sweaters
              </a>
              <a
                href="https://kaspreadsheet.com/category-914-Jackets.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Jackets
              </a>
              <a
                href="https://kaspreadsheet.com/category-920-Accessories.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Accessories
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white/40 uppercase tracking-wider mb-4">
              Resources
            </h4>
            <div className="space-y-2">
              <Link
                to="/blog/best-kakobuy-spreadsheet"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Size Guide
              </Link>
              <Link
                to="/blog/best-kakobuy-spreadsheet"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Shipping Calculator
              </Link>
              <Link
                to="/blog/best-kakobuy-spreadsheet"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                QC Guide
              </Link>
              <Link
                to="/blog/best-kakobuy-spreadsheet"
                className="block text-sm text-white/70 hover:text-white transition-colors"
              >
                Buyer Protection
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; 2026 Kakobuy Spreadsheet Hub. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-white/40">
              <span>Written by Fashion Buying Research Team</span>
              <span>|</span>
              <span>Updated June 2026</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}